/* 大ちゃんTools — テーマスクリプト
   営業日カレンダー / モバイルのカテゴリドロワー / 並び替え / 表示切替 /
   数量ステッパー / 画像サムネイル / トースト
*/
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- 営業日カレンダー ------------------------------------------ */

  function buildCalendar(host) {
    var closedWeekdays = (host.dataset.closedWeekdays || '')
      .split(',').map(function (s) { return parseInt(s, 10); })
      .filter(function (n) { return n >= 0 && n <= 6; });
    var closedDates = (host.dataset.closedDates || '')
      .split(/[,\n]/).map(function (s) { return s.trim(); }).filter(Boolean);
    var months = parseInt(host.dataset.months, 10) || 2;

    var today = new Date();
    var todayKey = ymd(today);
    var html = '';

    for (var m = 0; m < months; m++) {
      var cur = new Date(today.getFullYear(), today.getMonth() + m, 1);
      html += renderMonth(cur, closedWeekdays, closedDates, todayKey);
    }
    host.innerHTML = html;
  }

  function ymd(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function renderMonth(first, closedWeekdays, closedDates, todayKey) {
    var year = first.getFullYear();
    var month = first.getMonth();
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var startDow = first.getDay();
    var labels = ['日', '月', '火', '水', '木', '金', '土'];

    var out = '<div class="calendar"><div class="calendar__title">' +
      year + '年' + (month + 1) + '月の休業日</div><table><thead><tr>';
    labels.forEach(function (l, i) {
      out += '<th class="' + dowClass(i) + '">' + l + '</th>';
    });
    out += '</tr></thead><tbody><tr>';

    for (var pad = 0; pad < startDow; pad++) out += '<td></td>';

    for (var day = 1; day <= daysInMonth; day++) {
      var dow = (startDow + day - 1) % 7;
      var key = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
      var cls = [dowClass(dow)];
      if (closedWeekdays.indexOf(dow) !== -1 || closedDates.indexOf(key) !== -1) cls.push('off');
      if (key === todayKey) cls.push('today');
      out += '<td class="' + cls.join(' ') + '">' + day + '</td>';
      if (dow === 6 && day !== daysInMonth) out += '</tr><tr>';
    }

    var trailing = (7 - ((startDow + daysInMonth) % 7)) % 7;
    for (var t = 0; t < trailing; t++) out += '<td></td>';

    return out + '</tr></tbody></table></div>';
  }

  function dowClass(dow) {
    return dow === 0 ? 'sun' : dow === 6 ? 'sat' : '';
  }

  /* ---------- モバイル：カテゴリドロワー -------------------------------- */

  function initDrawer() {
    var toggle = $('.mobile-nav-toggle');
    var panel = $('#SideLeft');
    var scrim = $('#SideScrim');
    if (!toggle || !panel) return;

    function setOpen(open) {
      panel.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      setOpen(!panel.classList.contains('is-open'));
    });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
  }

  /* ---------- 一覧：並び替え / 表示切替 --------------------------------- */

  function initCollectionTools() {
    var sort = $('#SortBy');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var grid = $('#ProductGrid');
    $$('.view-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.view-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (grid) grid.classList.toggle('is-list', btn.dataset.view === 'list');
        try { localStorage.setItem('hm-view', btn.dataset.view); } catch (e) { /* プライベートモード等 */ }
      });
    });

    try {
      if (localStorage.getItem('hm-view') === 'list') {
        var listBtn = $('.view-btn[data-view="list"]');
        if (listBtn) listBtn.click();
      }
    } catch (e) { /* 読めなくても既定のグリッド表示で問題ない */ }
  }

  /* ---------- 商品ページ：数量 / サムネイル ------------------------------ */

  function initProduct() {
    var field = $('#Quantity');
    if (field) {
      $$('.qty-wrap .qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = btn.textContent.trim() === '+' ? 1 : -1;
          field.value = Math.max(1, (parseInt(field.value, 10) || 1) + delta);
        });
      });
    }

    var main = $('#ProductFeaturedImage');
    $$('.product-gallery__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main && thumb.dataset.src) main.src = thumb.dataset.src;
        $$('.product-gallery__thumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  /* ---------- 絞り込みの価格スライダー ----------------------------------- */

  function initPriceSlider() {
    var min = $('.price-slider--min');
    var max = $('.price-slider--max');
    var outMin = $('#FilterPriceMin');
    var outMax = $('#FilterPriceMax');
    if (!min || !max) return;

    function yen(v) { return '¥' + Number(v).toLocaleString('ja-JP'); }
    function sync() {
      // つまみが交差しないようにする
      if (Number(min.value) > Number(max.value)) min.value = max.value;
      if (outMin) outMin.textContent = yen(min.value);
      if (outMax) outMax.textContent = yen(max.value);
    }
    min.addEventListener('input', sync);
    max.addEventListener('input', sync);
    sync();
  }

  /* ---------- トースト ---------------------------------------------------- */

  function toast(message) {
    var wrap = $('.toast-wrap');
    if (!wrap) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    wrap.appendChild(el);
    setTimeout(function () { el.remove(); }, 2600);
  }

  /* ---------- 起動 -------------------------------------------------------- */

  function init() {
    var cal = $('#ShopCalendar');
    if (cal) buildCalendar(cal);
    initDrawer();
    initCollectionTools();
    initProduct();
    initPriceSlider();

    window.hmToast = toast;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* お問い合わせフォーム：選んだ用件に要る欄だけを開く。
   欄を全部見せると入力が重く、隠しすぎると往復が増えるので、用件で切り替える。 */
(function () {
  var form = document.getElementById('ContactForm');
  if (!form) return;
  var kinds = form.querySelectorAll('input[name="contact[\u3054\u7528\u4ef6]"]');
  var panels = form.querySelectorAll('.cform__when');

  function sync() {
    var picked = form.querySelector('input[name="contact[\u3054\u7528\u4ef6]"]:checked');
    var n = picked ? picked.getAttribute('data-kind') : '';
    for (var i = 0; i < panels.length; i++) {
      var on = panels[i].getAttribute('data-when').split(',').indexOf(n) >= 0;
      panels[i].hidden = !on;
      /* 隠れている欄が required だと、見えない場所で送信が止まる */
      var fields = panels[i].querySelectorAll('input, select, textarea');
      for (var j = 0; j < fields.length; j++) {
        if (on) {
          if (fields[j].getAttribute('data-req') === '1') fields[j].required = true;
        } else {
          if (fields[j].required) fields[j].setAttribute('data-req', '1');
          fields[j].required = false;
        }
      }
    }
  }
  for (var i = 0; i < kinds.length; i++) kinds[i].addEventListener('change', sync);
  sync();
})();


/* 調色依頼フォーム。
   ・「現物に合わせたい」を選んだときだけ、塗板の送付が要る旨を出す
   ・商品ページの「この商品を調色で依頼する」から来た場合、?product= を製品名欄に入れる */
(function () {
  var form = document.getElementById('TintRequestForm');
  if (!form) return;

  var q = new URLSearchParams(location.search).get('product');
  var maker = document.getElementById('TMaker');
  if (q && maker && !maker.value) maker.value = q;

  var books = form.querySelectorAll('input[name="contact[\u8272\u898b\u672c\u5e33]"]');
  var panels = form.querySelectorAll('.tint__when');
  function sync() {
    var picked = form.querySelector('input[name="contact[\u8272\u898b\u672c\u5e33]"]:checked');
    var n = picked ? picked.getAttribute('data-book') : '';
    for (var i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-book').split(',').indexOf(n) < 0;
    }
  }
  for (var i = 0; i < books.length; i++) books[i].addEventListener('change', sync);
  sync();
})();


/* 見積依頼フォームの品目行。
   ・最初は3行。「行を追加する」で隠してある行を1つずつ開く
   ・送信時、何も入っていない行の入力を無効にする
     （disabled は送信されないので、空欄だらけのメールにならない） */
(function () {
  var form = document.getElementById('QuoteRequestForm');
  if (!form) return;

  var extras = form.querySelectorAll('.qitem--extra');
  var more = form.querySelector('[data-add-row]');
  var rest = form.querySelector('[data-rest]');

  function left() {
    var n = 0;
    for (var i = 0; i < extras.length; i++) if (extras[i].hidden) n++;
    return n;
  }
  function sync() {
    if (!more) return;
    var n = left();
    if (rest) rest.textContent = n;
    more.hidden = n === 0;
  }
  if (more) {
    more.addEventListener('click', function () {
      for (var i = 0; i < extras.length; i++) {
        if (extras[i].hidden) { extras[i].hidden = false; break; }
      }
      sync();
    });
  }
  sync();

  form.addEventListener('submit', function () {
    var items = form.querySelectorAll('.qitem');
    for (var i = 0; i < items.length; i++) {
      var f = items[i].querySelectorAll('input, select');
      var filled = false;
      for (var j = 0; j < f.length; j++) if (String(f[j].value).trim()) filled = true;
      if (!filled) for (var k = 0; k < f.length; k++) f[k].disabled = true;
    }
  });
})();
